export default __webpack_public_path__ + "static/media/modern-machining-tools-min.5adfa8e9.jpg";